function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import merge from "lodash/merge";
import * as ActionTypes from "../../actions";

// Updates an entity cache in response to any action with response.entities.
var userFollowerEntities = function userFollowerEntities() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
    byId: {},
    byFolloweeIdAndUserId: {},
    byFolloweeIdAndConfirmedAtIsNull: {},
    byUserId: {}
  };
  var action = arguments.length > 1 ? arguments[1] : undefined;
  switch (action.type) {
    case ActionTypes.LOGIN_SUCCESS:
    case ActionTypes.GET_AUTHENTICATION_SUCCESS:
      var byId = _objectSpread({}, state.byId);
      var key = action.response.userId;
      var listItemArr = action.response.notificationListItemsByUserId[key];
      if (listItemArr) listItemArr.forEach(function (listItem) {
        return merge(byId, listItem.userFollowerById);
      });
      var listItemArr = action.response.notificationListItemsByUserIdAndViewedAtIsNull[key];
      if (listItemArr) listItemArr.forEach(function (listItem) {
        return merge(byId, listItem.userFollowerById);
      });
      return Object.assign({}, state, {
        byId: byId
      });
    case ActionTypes.GET_NOTIFICATIONTOASTSBYUSERID_SUCCESS:
    case ActionTypes.GET_NOTIFICATIONTOASTSBYUSERIDANDVIEWEDATISNULL_SUCCESS:
      var byId = {};
      action.response.forEach(function (toast) {
        return merge(byId, toast.userFollowerById);
      });
      return merge({}, state, {
        byId: byId
      });
    case ActionTypes.GET_EVENTLISTITEMSBYUSERIDANDEVENTTYPEIDIN_SUCCESS:
      var byId = {};
      action.response.forEach(function (eventListItem) {
        return merge(byId, eventListItem.userFollowerById);
      });
      return merge({}, state, {
        byId: byId
      });
    case ActionTypes.GET_NOTIFICATIONTABBYUSERID_SUCCESS:
      var byId = _objectSpread({}, state.byId);
      action.response.notificationListItemsByUserId[action.userId].forEach(function (listItem) {
        return merge(byId, listItem.userFollowerById);
      });
      var byFolloweeIdAndConfirmedAtIsNull = action.response.userFollowersByFolloweeIdAndConfirmedAtIsNull;
      return Object.assign({}, state, {
        byId: byId,
        byFolloweeIdAndConfirmedAtIsNull: byFolloweeIdAndConfirmedAtIsNull
      });
    case ActionTypes.GET_USERVIEWBYFOLLOWEEUSERNAMEANDAUTHUSERID_SUCCESS:
      var byFolloweeIdAndUserId = action.response.userFollowerByFolloweeIdAndUserId;
      return merge({}, state, {
        byFolloweeIdAndUserId: byFolloweeIdAndUserId
      });
    case ActionTypes.POST_USERFOLLOWER_SUCCESS:
      if (!action.userFollower.id && action.userFollower.followeeId && action.userFollower.userId) {
        var embedded = action.response._embedded;
        var key = [action.userFollower.followeeId, action.userFollower.userId].join("-");
        var byFolloweeIdAndUserId = _objectSpread({}, state.byFolloweeIdAndUserId);
        byFolloweeIdAndUserId[key] = embedded;
        state = merge({}, state, {
          byFolloweeIdAndUserId: byFolloweeIdAndUserId,
          byUserId: byUserId
        });
      }
      if (action.userFollower.followee && state.byFolloweeIdAndConfirmedAtIsNull[action.userFollower.followee.id]) {
        var byFolloweeIdAndConfirmedAtIsNull = _objectSpread({}, state.byFolloweeIdAndConfirmedAtIsNull);
        var embedded = action.response._embedded;
        var key = action.userFollower.followee.id;
        byFolloweeIdAndConfirmedAtIsNull[key] = byFolloweeIdAndConfirmedAtIsNull[key].map(function (userFollower) {
          return userFollower.id === action.userFollower.id ? embedded : userFollower;
        }).filter(function (userFollower) {
          return userFollower.id !== action.userFollower.id || !embedded.confirmedAt;
        });
        return Object.assign({}, state, {
          byFolloweeIdAndConfirmedAtIsNull: byFolloweeIdAndConfirmedAtIsNull
        });
      }
      return state;
    case ActionTypes.DELETE_USERFOLLOWER_SUCCESS:
      var byFolloweeIdAndConfirmedAtIsNull = _objectSpread({}, state.byFolloweeIdAndConfirmedAtIsNull);
      Object.keys(state.byFolloweeIdAndConfirmedAtIsNull).map(function (key) {
        byFolloweeIdAndConfirmedAtIsNull[key] = state.byFolloweeIdAndConfirmedAtIsNull[key].filter(function (userFollower) {
          return userFollower.id !== action.userFollower.id;
        });
      });
      var byFolloweeIdAndUserId = _objectSpread({}, state.byFolloweeIdAndUserId);
      Object.keys(state.byFolloweeIdAndUserId).map(function (key) {
        var userFollower = state.byFolloweeIdAndUserId[key];
        if (userFollower && userFollower.id === action.userFollower.id) byFolloweeIdAndUserId[key] = undefined;
      });
      var byUserId = _objectSpread({}, state.byUserId);
      Object.keys(state.byUserId).map(function (key) {
        byUserId[key] = state.byUserId[key].filter(function (userFollower) {
          return userFollower.id !== action.userFollower.id;
        });
      });
      return Object.assign({}, state, {
        byFolloweeIdAndConfirmedAtIsNull: byFolloweeIdAndConfirmedAtIsNull,
        byFolloweeIdAndUserId: byFolloweeIdAndUserId
      });
    case ActionTypes.GET_USERSVIEWBYAUTHUSERID_SUCCESS:
      var byFolloweeIdAndUserId = action.response.userFollowerByFolloweeIdAndUserId;
      return merge({}, state, {
        byFolloweeIdAndUserId: byFolloweeIdAndUserId
      });
    case ActionTypes.GET_USERFOLLOWERLISTITEMSBYFOLLOWEEIDANDCONFIRMEDATISNOTNULLANDAUTHUSERID_SUCCESS:
    case ActionTypes.GET_USERFOLLOWERLISTITEMSBYUSERIDANDCONFIRMEDATISNOTNULLANDAUTHUSERID_SUCCESS:
    case ActionTypes.GET_POSTREACTIONLISTITEMSBYPOSTIDANDAUTHUSERID_SUCCESS:
      var byId = _objectSpread({}, state.byId);
      action.response.forEach(function (listItem) {
        return merge(byId, listItem.userFollowerById);
      });
      var byFolloweeIdAndUserId = _objectSpread({}, state.byFolloweeIdAndUserId);
      action.response.forEach(function (listItem) {
        return merge(byFolloweeIdAndUserId, listItem.userFollowerByFolloweeIdAndUserId);
      });
      return Object.assign({}, state, {
        byFolloweeIdAndUserId: byFolloweeIdAndUserId,
        byId: byId
      });
    default:
      return state;
  }
};
export default userFollowerEntities;